module.exports = __webpack_public_path__ + "media/images/personnel/Russ_Orlov-77ae0a7b1f35e0ad789bf58a6310b1e8.png";